/* eslint-disable no-alert */
/* eslint-disable no-nested-ternary */
import { Base64 } from 'js-base64'
import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Switch from 'react-switch'

import { CircularProgress } from '@material-ui/core'
import { FiCheck, FiClock } from 'react-icons/fi'

import usePersistedState from '../../hooks/usePersistedState'
import api from '../../services/api'

import Button from '../../components/Button'
import Header from '../../components/Header'
import ModalBox from '../../components/Modal'

import Container from '../../components/Container'
import {
  ConfigData,
  ErroProps,
  Participant,
  UserData,
  UserDetails,
} from '../../utils/interfaces'
import { BtnVoltar, Confirmation, Content } from './styles'

const Conclusion: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)

  const [configData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )
  const [userDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )
  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )
  const [, setErroProps] = usePersistedState<ErroProps>(
    'erroProps',
    {} as ErroProps,
  )
  const [selectedReceive] = usePersistedState<'PD' | 'PS' | 'null'>(
    'receiveTypeSelected',
    'PD',
  )
  const [tipCtbBasica] = usePersistedState('tipCtbBasica', '') // P = Percentual sobre o salário || M = Máxima permitida pelo plano
  const [tipCtbAdic] = usePersistedState('tipCtbAdic', '') // P = Percentual sobre o salário || F = Valor fixo
  const [ads] = usePersistedState('ads', false)

  const [aguarde, setAguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)

  const [acceptTerms, setAcceptTerms] = useState(false)

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [warningText, setWarningText] = useState('')

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  const history = useHistory()

  const handleConfirmaAdesao = useCallback(async () => {
    setAguarde(true)
    const parametros = Base64.encode(
      `{
        "token": "${configData.token}",
        "versao": "${configData.tipo}",
        "cliente": "${configData.codCliente}",
        "plano": "${configData.plano}",
        "nome": "${userData.name.toLowerCase()}",
        "cpf": "${userData.cpf.replaceAll('.', '').replace('-', '')}",
        "nascimento": "${
          userData.birthdate === undefined ? '' : userData.birthdate
        }",
        "email": "${userData.email}",
        "telefone": "55${userData.phone
          .replace('(', '')
          .replace(') ', '')
          .replace('-', '')}",
        "patrocinadora":"${userData.patrocinadora}",
        "salario": "${userDetails.salario}",
        "permiteContato": "${ads ? 'S' : 'N'}",
        "valor": "${userDetails.contribuicaoBasica
          .toString()
          .replace('.', ',')}",
        "metCalcCtbBasica":"${tipCtbBasica === 'M' ? 7 : 1}",
        "pctCtbBasica": "${userDetails.pctContribuicaoBasica
          .toString()
          .replace('.', ',')}",
        "valorsuplementar": "${userDetails.contribuicaoSuplementar
          .toString()
          .replace('.', ',')}",
        "pctCtbSuplementar": "${
          tipCtbAdic === 'P'
            ? userDetails.pctContribuicaoSuplementar
                .toString()
                .replace('.', ',')
            : 0
        }",
        "idade_apos":"${userDetails.age === undefined ? '' : userDetails.age}",
        "tempo_contribuicao": "${
          userDetails.years === undefined ? 0 : userDetails.years
        }",
        "politicamenteexposto": "${userDetails.pep}",
        "forma_resgate": "${
          selectedReceive === undefined ? '' : selectedReceive
        }",
        "beneficiarios": [${participants.map(
          participant => `
          {"nome": "${participant.data.name.toLowerCase()}",
          "nascimento": "${participant.data.birthdate}",
          "parentesco":"${participant.details.grauParentesco}",
          "tipo":"${participant.details.tipoBen}",
          "cpf": "${participant.data.cpf.replaceAll('.', '').replace('-', '')}",
          "fator":"${
            participant.details.proporcao === undefined
              ? '0'
              : participant.details.proporcao.toString().replace('.', ',')
          }"}`,
        )}]
        }`,
    )

    const parametrosFinal = Base64.encode(parametros)

    // history.push('/end')

    await api
      .post(`wsAdesao.rule?sys=ADZ&Entrada=${parametrosFinal}`)
      .then(() => {
        localStorage.removeItem('@BASF:configData')
        localStorage.removeItem('@BASF:participantsGroup')
        localStorage.removeItem('@BASF:PercentualValuePercent')
        localStorage.removeItem('@BASF:receiveTypeSelected')
        localStorage.removeItem('@BASF:TimeValueYears')
        localStorage.removeItem('@BASF:totalBalance')
        localStorage.removeItem('@BASF:userData')
        localStorage.removeItem('@BASF:userDetails')
        localStorage.removeItem('@BASF:erroProps')
        localStorage.removeItem('@BASF:acceptTerms')
        localStorage.removeItem('@BASF:RendaFixaValue')
        localStorage.removeItem('@BASF:flagEdit')
        localStorage.removeItem('@BASF:evolSal')
        localStorage.removeItem('@BASF:flagSimul')
        localStorage.removeItem('@BASF:accessionConfig')
        localStorage.removeItem('@BASF:tamanhoCodigoValidador')
        localStorage.removeItem('@BASF:usb')
        localStorage.removeItem('@BASF:@BASF:pctSobreSaldo')
        localStorage.removeItem('@BASF:@BASF:rentAnual')
        localStorage.removeItem('@BASF:@BASF:rentMensal')
        localStorage.removeItem('@BASF:@BASF:tipCtbAdic')
        localStorage.removeItem('@BASF:@BASF:tipCtbBasica')

        history.push('/end')
      })
      .catch(res => {
        if (res.message === 'Request failed with status code 401') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else if (res.message === 'Request failed with status code 406') {
          setWarningText(
            'Adesão não autorizada. Verifique se você já possui cadastro no plano.',
          )
          setIsModalOpen(true)
          setReSend(false)
          setTimer(20)
          setAguarde(false)
        } else if (res.message === 'Network Error') {
          setErroProps({
            title: res.message,
            description: 'Falha na conexão como servidor',
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 500') {
          setErroProps({
            title: 'Erro interno no servidor',
            description: res.message,
          })
          history.push('/erro')
        } else if (res.message === 'Request failed with status code 408') {
          alert('Tempo de sessão expirado')
          history.push('/register')
        } else {
          setReSend(false)
          setTimer(20)
          setAguarde(false)
          setWarningText('Ops, algo deu errado. Tente novamente mais tarde.')
          setIsModalOpen(true)
        }
      })
  }, [
    ads,
    configData,
    history,
    participants,
    selectedReceive,
    setErroProps,
    tipCtbAdic,
    tipCtbBasica,
    userData,
    userDetails,
  ])

  const toggleAcceptTerms = useCallback(() => {
    setAcceptTerms(!acceptTerms)
  }, [acceptTerms, setAcceptTerms])

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <strong>Declaração/Autorização</strong>
          <Confirmation>
            <ol>
              <li>
                A(s) contribuição(ões), acima indicada(s), será(ão) efetuada(s)
                mensalmente, 12 vezes ao ano, mediante descontos regulares na
                folha de pagamento, podendo ser alterada(s) a qualquer momento,
                mediante solicitação à Entidade, por meio de formulário
                específico e respeitando sempre os limites da tabela de
                contribuição vigente.
              </li>
              <li>
                Os recursos administrados pela BASF Previdência são investidos
                no mercado financeiro e de capitais e estão sujeitos aos riscos
                compatíveis com cada classe de ativo. A descrição completa da
                estrutura dos investimentos pode ser encontrada na Política de
                Investimentos vigente, no sítio eletrônico da Entidade.
              </li>
              <li>
                Não há qualquer garantia contra eventuais perdas patrimoniais
                que possam ser incorridas pelo Fundo.
              </li>
              <li>
                Esse documento é firmado físico ou eletronicamente, sendo este
                último através da plataforma AdobeSign, com ou sem a utilização
                de certificado digital emitido no padrão estabelecido pela
                ICP-Brasil, reputando-se plenamente válido, em todo o seu
                conteúdo, a partir da aposição da última assinatura, informação
                essa que será reconhecida pelas partes em sua integridade e
                autenticidade, garantidas por sistema de criptografia, em
                conformidade com o artigo 10, § 2, da Medida Provisória
                2200-2/2001 bem como legislação superveniente. Os signatários
                declaram ser os legítimos representantes das Partes e possuir
                poderes para firmar este Contrato.
              </li>
              <li>
                O(A) Participante desde já declara, reconhece e autoriza o
                tratamento de seus dados pessoais pela BASF Previdência, em
                concordância com a Lei 13.853/2019 – Lei Geral de Proteção de
                Dados, única e exclusivamente para possibilitar as operações
                junto a BASF Previdência, para fins estatísticos e gerenciais
                internamente, envio de mensagens SMS/e-mail/WhatsApp, obrigações
                legais, fornecedores e bancos, e pelo tempo previsto em
                legislação vigente.
              </li>
              <li>
                informa que o tratamento dos dados pessoais será realizado via
                canal de autoatendimento, interface ou arquivo das empresas do
                Grupo BASF. Seus dados pessoais permanecem com a nossa empresa,
                nossas afiliadas, e nosso provedor, e poderão ser compartilhados
                pela BASF Previdência somente com seus fornecedores/prestadores
                de serviços que necessitem ter acesso a tais dados para o
                cumprimento de suas obrigações junto à BASF Previdência
              </li>
              <li>
                A BASF Previdência. Nesta hipótese, tais
                fornecedores/prestadores de serviços somente poderão utilizar
                seus dados pessoais de acordo com as nossas instruções e as
                finalidades aqui previstas, e encontram-se contratualmente
                obrigados a cumprir com os requisitos legais de proteção de
                dados aplicáveis.
              </li>
            </ol>
            <p>
              Eu, {userData.name}, inscrito no CPF <b>{userData.cpf}</b>,
              declaro que ao clicar em <b>Confirmar Adesão</b> estou confirmando
              minha adesão ao <b>Plano BASF Previdência</b> e que as informações
              prestadas são verídicas.
            </p>
            <div>
              <small>
                Declaro que li e estou de acordo com o{' '}
                <a
                  href="https://imagens.universalprev.com.br/efpc/basf/docs/Regulamento_BASF_Previdencia2023.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  regulamento do plano
                </a>
              </small>
              <Switch
                onChange={toggleAcceptTerms}
                checked={acceptTerms}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={40}
                handleDiameter={16}
                offColor="#DEE3E1"
                offHandleColor="#fff"
                onHandleColor="#fff"
                onColor="#31D19E"
              />
            </div>
          </Confirmation>
        </Content>

        <Button
          type="button"
          color="orange"
          width="large"
          disabled={!acceptTerms || !reSend || aguarde}
          onClick={handleConfirmaAdesao}
        >
          {!aguarde ? (
            !reSend ? (
              <>
                <FiClock size={45} />
                <span>
                  Tente novamente em {timer < 10 ? `0${timer}` : timer} segundos
                </span>
              </>
            ) : (
              <>
                <FiCheck size={45} />
                <span>Confirmar adesão</span>
              </>
            )
          ) : (
            <>
              <CircularProgress color="inherit" />
              <span>Aguarde</span>
            </>
          )}
        </Button>
        <BtnVoltar type="button" onClick={() => history.push('/resume')}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          <p>{warningText}</p>
        </ModalBox>
      </Container>
    </>
  )
}

export default Conclusion
